import React from "react";
import { Box, Typography } from "@mui/material";
import "./Footer.css";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: "auto",
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Internal tool — map validation runs in the browser until the API is enabled.
      </Typography>
    </Box>
  );
}

export default Footer;
